import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Report } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_CHALLENGE_REPORT_ID = 'get-challenge-report-id';

export const useGetChallengeReport = (
  challengeSettingId: number,
  startDate: string,
  endDate: string,
) => {
  return usePermittedQuery<Report>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () =>
      `/submission/challenge/progress?startDate=${startDate}&endDate=${endDate}&exerciseSettingId=${challengeSettingId}`,
    {},
    [GET_CHALLENGE_REPORT_ID, challengeSettingId],
    {
      enabled: typeof challengeSettingId === 'number' && challengeSettingId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
